module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_honda_03.a8408e46.jpg";